export default function shouldPreventUnload(e, isPrevented, isRunningInTestRuntime) {
  const isOnLoginPage = ['login', 'logout', null].includes(localStorage.getItem('purpose'));

  if (isPrevented && !isRunningInTestRuntime && !isOnLoginPage) {
    e.preventDefault();
    // Chrome requires returnValue to be set.
    e.returnValue = '';
  }
}
